import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import {
  getQueryParams,
  isoToSqlDate,
  mergeParams,
} from "../../helpers/helpers";
import AppContext from "../../container/context";
import api from "../../services/api";
import MUIDataTable from "mui-datatables";
import pedidoEvento from "../../enums/pedidoEvento";

const dataAtual = new Date();

export default function RelatorioParticipacao({ history, location }) {
  const { notification } = useContext(AppContext);
  const [registros, setRegistros] = useState([]);
  const [totais, setTotais] = useState({});
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        escolaNomeFantasia: '',
        situacao: 0,
        mesInicio: 1,
        anoInicio: dataAtual.getFullYear(),
        mesFim: dataAtual.getMonth() + 1,
        anoFim: dataAtual.getFullYear(),
      },
      location,
    ),
  );

  useEffect(() => {
    const parametros = getQueryParams(location.search);

    if (parametros.dataInicial && parametros.dataFinal) {
      carregarRelatorio();
    }
  }, []);

  const carregarRelatorio = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);

    api
      .get("relatorios/auditoriaPedidosFaturas", filtrosEnviar)
      .then((registros) => {
        console.log('registros', registros);

        registros.regulares.forEach(r => {
          r.vencimento = `${r.vencimentoMes}/${r.vencimentoAno}`;
          r.valorVencimentos = (r.valor/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.valorFatura = (r.faturaValorCentavos/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.faturaIugu = <a href={r.faturaLinkIugu} target="_blank">{r.faturaLinkIugu}</a>
        });

        registros.valorPagoMaior.forEach(r => {
          r.vencimento = `${r.vencimentoMes}/${r.vencimentoAno}`;
          r.valorVencimentos = (r.valor/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.valorFatura = (r.faturaValorCentavos/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.faturaIugu = <a href={r.faturaLinkIugu} target="_blank">{r.faturaLinkIugu}</a>
        });

        registros.valorPagoComDesconto.forEach(r => {
          r.vencimento = `${r.vencimentoMes}/${r.vencimentoAno}`;
          r.valorVencimentos = (r.valor/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.valorFatura = (r.faturaValorCentavos/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.faturaIugu = <a href={r.faturaLinkIugu} target="_blank">{r.faturaLinkIugu}</a>;
          r.valorDesconto = (r.faturaValorDesconto/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
        });

        registros.valorPagoMenor.forEach(r => {
          r.vencimento = `${r.vencimentoMes}/${r.vencimentoAno}`;
          r.valorVencimentos = (r.valor/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.valorFatura = (r.faturaValorCentavos/100).toLocaleString("pt-BR", {style: 'currency', currency: "BRL"});
          r.faturaIugu = <a href={r.faturaLinkIugu} target="_blank">{r.faturaLinkIugu}</a>
        });

        setTotais({
          regulares: registros.regulares.length,
          valorPagoMaior: registros.valorPagoMaior.length,
          valorPagoMenor: registros.valorPagoMenor.length
        });

        setRegistros(registros);
      })
      .catch((err) => {
        console.log('err', err);
        notification("error", "Erro ao carregar o relatório");
      });
  };

  const fFiltros = {
    title: 'Filtros',
    form: {
      mesInicio: {
        label: 'Mês (a partir de)',
        type: 'select',
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: 'id',
          desc: 'nome',
        },
        value: filtros.mesInicio,
      },
      anoInicio: {
        label: 'Ano (a partir de)',
        type: 'select',
        value: filtros.anoInicio,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = 2024;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      },
      mesFim: {
        label: 'Mês (até)',
        type: 'select',
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: 'id',
          desc: 'nome',
        },
        value: filtros.mesFim,
      },
      anoFim: {
        label: 'Ano (até)',
        type: 'select',
        value: filtros.anoFim,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = 2024;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      },
    },
    submit: {
      label: 'Listar',
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      regulares: {
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Regulares</h4>
            <h4 style={{color: 'green', fontWeight: 'bolder'}}>{totais.regulares}</h4>
          </div>
        ),
      },
      valorPagoMaior: {
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Pagamentos com valor maior</h4>
            <h4 style={{color: 'orange', fontWeight: 'bolder'}}>{totais.valorPagoMaior}</h4>
          </div>
        ),
      },
      valorPagoMenor: {
        type: "component",
        space: 4,
        value: (
          <div>
            <h4>Pagamentos com valor menor</h4>
            <h4 style={{color: 'red', fontWeight: 'bolder'}}>{totais.valorPagoMenor}</h4>
          </div>
        ),
      },
    },
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {registros.regulares?.length > 0 && <Form formData={fTotais} />}
      {registros.valorPagoMenor?.length > 0 && (
        <div style={{marginTop: 10}}>
          <MUIDataTable
            title={<h3 style={{color: 'red'}}>{"Pagamentos com valor menor"}</h3>}
            data={registros.valorPagoMenor}
            columns={columns}
            options={options}
          />
        </div>
        
      )}
      {registros.valorPagoComDesconto?.length > 0 && (
        <div style={{marginTop: 10}}>
          <MUIDataTable
            title={<h3 style={{color: 'orange'}}>{"Pagamentos com desconto"}</h3>}
            data={registros.valorPagoComDesconto}
            columns={columnsDisc}
            options={options}
          />
        </div>
      )}
      {registros.valorPagoMaior?.length > 0 && (
        <div style={{marginTop: 10}}>
          <MUIDataTable
            title={<h3 style={{color: 'orange'}}>{"Pagamentos com valor maior"}</h3>}
            data={registros.valorPagoMaior}
            columns={columns}
            options={options}
          />
        </div>
      )}
      {registros.regulares?.length > 0 && (
        <div style={{marginTop: 10}}>
          <MUIDataTable
            title={<h3 style={{color: 'green'}}>{"Regulares"}</h3>}
            data={registros.regulares}
            columns={columns}
            options={options}
          />
        </div>
      )}
    </div>
  );
}

const columns = [
  {
    name: "escolaNomeFantasia",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "vencimento",
    label: "Vencimento",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "valorVencimentos",
    label: "Valor (vencimentos mês)",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "valorFatura",
    label: "Valor da fatura (fatura)",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "faturaIugu",
    label: "Fatura (Iugu)",
    options: {
      filter: false,
      sort: true,
    },
  }
];

const columnsDisc = [
  ...columns,
  {
    name: "valorDesconto",
    label: "Desconto (R$)",
    options: {
      filter: false,
      sort: false,
    },
  }
]

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 10,
  downloadOptions: {
    filename: "participacao.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
};

const meses = [
  { id: '1', nome: 'Janeiro' },
  { id: '2', nome: 'Fevereiro' },
  { id: '3', nome: 'Março' },
  { id: '4', nome: 'Abril' },
  { id: '5', nome: 'Maio' },
  { id: '6', nome: 'Junho' },
  { id: '7', nome: 'Julho' },
  { id: '8', nome: 'Agosto' },
  { id: '9', nome: 'Setembro' },
  { id: '10', nome: 'Outubro' },
  { id: '11', nome: 'Novembro' },
  { id: '12', nome: 'Dezembro' },
];